var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParaplusQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_113)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161 0H0V161H161V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_113",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 149,
    height: 149
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 46.69H6.11804V51.198H10.626V46.69Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 51.198H6.11804V55.706H10.626V51.198Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 55.706H6.11804V60.214H10.626V55.706Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 64.722H6.11804V69.23H10.626V64.722Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 82.754H6.11804V87.262H10.626V82.754Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 87.262H6.11804V91.77H10.626V87.262Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 96.278H6.11804V100.786H10.626V96.278Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 109.802H6.11804V114.31H10.626V109.802Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1341 51.198H10.6261V55.706H15.1341V51.198Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1341 69.23H10.6261V73.738H15.1341V69.23Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1341 73.738H10.6261V78.246H15.1341V73.738Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1341 78.246H10.6261V82.754H15.1341V78.246Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1341 82.754H10.6261V87.262H15.1341V82.754Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1341 91.77H10.6261V96.278H15.1341V91.77Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1341 114.31H10.6261V118.818H15.1341V114.31Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.642 42.182H15.134V46.69H19.642V42.182Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.642 46.69H15.134V51.198H19.642V46.69Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.642 51.198H15.134V55.706H19.642V51.198Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.642 78.246H15.134V82.754H19.642V78.246Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.642 96.278H15.134V100.786H19.642V96.278Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.642 100.786H15.134V105.294H19.642V100.786Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.642 105.294H15.134V109.802H19.642V105.294Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.642 109.802H15.134V114.31H19.642V109.802Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 51.198H19.6421V55.706H24.1501V51.198Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 73.738H19.6421V78.246H24.1501V73.738Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 78.246H19.6421V82.754H24.1501V78.246Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 82.754H19.6421V87.262H24.1501V82.754Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 87.262H19.6421V91.77H24.1501V87.262Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 109.802H19.6421V114.31H24.1501V109.802Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 114.31H19.6421V118.818H24.1501V114.31Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 42.182H24.15V46.69H28.658V42.182Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 51.198H24.15V55.706H28.658V51.198Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 55.706H24.15V60.214H28.658V55.706Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 60.214H24.15V64.722H28.658V60.214Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 69.23H24.15V73.738H28.658V69.23Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 73.738H24.15V78.246H28.658V73.738Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 78.246H24.15V82.754H28.658V78.246Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 82.754H24.15V87.262H28.658V82.754Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 87.262H24.15V91.77H28.658V87.262Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 91.77H24.15V96.278H28.658V91.77Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 96.278H24.15V100.786H28.658V96.278Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 100.786H24.15V105.294H28.658V100.786Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 109.802H24.15V114.31H28.658V109.802Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1661 42.182H28.6581V46.69H33.1661V42.182Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1661 46.69H28.6581V51.198H33.1661V46.69Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1661 55.706H28.6581V60.214H33.1661V55.706Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1661 69.23H28.6581V73.738H33.1661V69.23Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1661 73.738H28.6581V78.246H33.1661V73.738Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1661 78.246H28.6581V82.754H33.1661V78.246Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1661 82.754H28.6581V87.262H33.1661V82.754Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1661 91.77H28.6581V96.278H33.1661V91.77Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1661 105.294H28.6581V109.802H33.1661V105.294Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M37.674 42.182H33.166V46.69H37.674V42.182Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M37.674 51.198H33.166V55.706H37.674V51.198Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M37.674 60.214H33.166V64.722H37.674V60.214Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M37.674 69.23H33.166V73.738H37.674V69.23Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M37.674 78.246H33.166V82.754H37.674V78.246Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M37.674 87.262H33.166V91.77H37.674V87.262Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M37.674 96.278H33.166V100.786H37.674V96.278Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M37.674 105.294H33.166V109.802H37.674V105.294Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M37.674 114.31H33.166V118.818H37.674V114.31Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1821 46.69H37.6741V51.198H42.1821V46.69Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1821 55.706H37.6741V60.214H42.1821V55.706Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1821 64.722H37.6741V69.23H42.1821V64.722Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1821 69.23H37.6741V73.738H42.1821V69.23Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1821 82.754H37.6741V87.262H42.1821V82.754Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1821 91.77H37.6741V96.278H42.1821V91.77Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1821 100.786H37.6741V105.294H42.1821V100.786Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1821 105.294H37.6741V109.802H42.1821V105.294Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1821 114.31H37.6741V118.818H42.1821V114.31Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 10.626H42.182V15.134H46.69V10.626Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 24.15H42.182V28.658H46.69V24.15Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 33.166H42.182V37.674H46.69V33.166Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 42.182H42.182V46.69H46.69V42.182Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 78.246H42.182V82.754H46.69V78.246Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 82.754H42.182V87.262H46.69V82.754Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 91.77H42.182V96.278H46.69V91.77Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 96.278H42.182V100.786H46.69V96.278Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 100.786H42.182V105.294H46.69V100.786Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 105.294H42.182V109.802H46.69V105.294Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 109.802H42.182V114.31H46.69V109.802Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 118.818H42.182V123.326H46.69V118.818Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 127.834H42.182V132.342H46.69V127.834Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 132.342H42.182V136.85H46.69V132.342Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69 141.358H42.182V145.866H46.69V141.358Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 10.626H46.6901V15.134H51.1981V10.626Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 15.134H46.6901V19.642H51.1981V15.134Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 19.642H46.6901V24.15H51.1981V19.642Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 42.182H46.6901V46.69H51.1981V42.182Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 46.69H46.6901V51.198H51.1981V46.69Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 64.722H46.6901V69.23H51.1981V64.722Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 69.23H46.6901V73.738H51.1981V69.23Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 73.738H46.6901V78.246H51.1981V73.738Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 87.262H46.6901V91.77H51.1981V87.262Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 105.294H46.6901V109.802H51.1981V105.294Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 109.802H46.6901V114.31H51.1981V109.802Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 118.818H46.6901V123.326H51.1981V118.818Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 136.85H46.6901V141.358H51.1981V136.85Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 141.358H46.6901V145.866H51.1981V141.358Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 145.866H46.6901V150.374H51.1981V145.866Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 6.118H51.198V10.626H55.706V6.118Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 10.626H51.198V15.134H55.706V10.626Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 19.642H51.198V24.15H55.706V19.642Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 28.658H51.198V33.166H55.706V28.658Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 33.166H51.198V37.674H55.706V33.166Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 37.674H51.198V42.182H55.706V37.674Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 42.182H51.198V46.69H55.706V42.182Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 55.706H51.198V60.214H55.706V55.706Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 60.214H51.198V64.722H55.706V60.214Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 73.738H51.198V78.246H55.706V73.738Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 82.754H51.198V87.262H55.706V82.754Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 96.278H51.198V100.786H55.706V96.278Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 100.786H51.198V105.294H55.706V100.786Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 105.294H51.198V109.802H55.706V105.294Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 109.802H51.198V114.31H55.706V109.802Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 114.31H51.198V118.818H55.706V114.31Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 118.818H51.198V123.326H55.706V118.818Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 123.326H51.198V127.834H55.706V123.326Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 136.85H51.198V141.358H55.706V136.85Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M55.706 145.866H51.198V150.374H55.706V145.866Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 10.626H55.7061V15.134H60.2141V10.626Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 19.642H55.7061V24.15H60.2141V19.642Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 24.15H55.7061V28.658H60.2141V24.15Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 28.658H55.7061V33.166H60.2141V28.658Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 37.674H55.7061V42.182H60.2141V37.674Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 55.706H55.7061V60.214H60.2141V55.706Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 69.23H55.7061V73.738H60.2141V69.23Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 78.246H55.7061V82.754H60.2141V78.246Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 82.754H55.7061V87.262H60.2141V82.754Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 87.262H55.7061V91.77H60.2141V87.262Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 91.77H55.7061V96.278H60.2141V91.77Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 96.278H55.7061V100.786H60.2141V96.278Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 100.786H55.7061V105.294H60.2141V100.786Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 109.802H55.7061V114.31H60.2141V109.802Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 123.326H55.7061V127.834H60.2141V123.326Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2141 150.374H55.7061V154.882H60.2141V150.374Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 6.118H60.214V10.626H64.722V6.118Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 10.626H60.214V15.134H64.722V10.626Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 28.658H60.214V33.166H64.722V28.658Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 33.166H60.214V37.674H64.722V33.166Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 42.182H60.214V46.69H64.722V42.182Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 46.69H60.214V51.198H64.722V46.69Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 55.706H60.214V60.214H64.722V55.706Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 60.214H60.214V64.722H64.722V60.214Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 64.722H60.214V69.23H64.722V64.722Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 87.262H60.214V91.77H64.722V87.262Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 91.77H60.214V96.278H64.722V91.77Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 100.786H60.214V105.294H64.722V100.786Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 105.294H60.214V109.802H64.722V105.294Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 123.326H60.214V127.834H64.722V123.326Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 132.342H60.214V136.85H64.722V132.342Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 136.85H60.214V141.358H64.722V136.85Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M69.23 15.134H64.722V19.642H69.23V15.134Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M69.23 37.674H64.722V42.182H69.23V37.674Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M69.23 73.738H64.722V78.246H69.23V73.738Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M69.23 78.246H64.722V82.754H69.23V78.246Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M69.23 105.294H64.722V109.802H69.23V105.294Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M69.23 118.818H64.722V123.326H69.23V118.818Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M69.23 127.834H64.722V132.342H69.23V127.834Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 10.626H69.23V15.134H73.738V10.626Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 24.15H69.23V28.658H73.738V24.15Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 33.166H69.23V37.674H73.738V33.166Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 37.674H69.23V42.182H73.738V37.674Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 46.69H69.23V51.198H73.738V46.69Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 55.706H69.23V60.214H73.738V55.706Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 73.738H69.23V78.246H73.738V73.738Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 82.754H69.23V87.262H73.738V82.754Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 96.278H69.23V100.786H73.738V96.278Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 100.786H69.23V105.294H73.738V100.786Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 109.802H69.23V114.31H73.738V109.802Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 118.818H69.23V123.326H73.738V118.818Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 123.326H69.23V127.834H73.738V123.326Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 141.358H69.23V145.866H73.738V141.358Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 145.866H69.23V150.374H73.738V145.866Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 6.118H73.738V10.626H78.246V6.118Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 10.626H73.738V15.134H78.246V10.626Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 15.134H73.738V19.642H78.246V15.134Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 51.198H73.738V55.706H78.246V51.198Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 55.706H73.738V60.214H78.246V55.706Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 60.214H73.738V64.722H78.246V60.214Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 64.722H73.738V69.23H78.246V64.722Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 69.23H73.738V73.738H78.246V69.23Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 82.754H73.738V87.262H78.246V82.754Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 87.262H73.738V91.77H78.246V87.262Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 96.278H73.738V100.786H78.246V96.278Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 100.786H73.738V105.294H78.246V100.786Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 109.802H73.738V114.31H78.246V109.802Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 114.31H73.738V118.818H78.246V114.31Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 118.818H73.738V123.326H78.246V118.818Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 123.326H73.738V127.834H78.246V123.326Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 132.342H73.738V136.85H78.246V132.342Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M78.246 136.85H73.738V141.358H78.246V136.85Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 33.166H78.2461V37.674H82.7541V33.166Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 37.674H78.2461V42.182H82.7541V37.674Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 42.182H78.2461V46.69H82.7541V42.182Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 51.198H78.2461V55.706H82.7541V51.198Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 55.706H78.2461V60.214H82.7541V55.706Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 73.738H78.2461V78.246H82.7541V73.738Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 78.246H78.2461V82.754H82.7541V78.246Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 91.77H78.2461V96.278H82.7541V91.77Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 96.278H78.2461V100.786H82.7541V96.278Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 100.786H78.2461V105.294H82.7541V100.786Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 105.294H78.2461V109.802H82.7541V105.294Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 114.31H78.2461V118.818H82.7541V114.31Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 123.326H78.2461V127.834H82.7541V123.326Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 132.342H78.2461V136.85H82.7541V132.342Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7541 145.866H78.2461V150.374H82.7541V145.866Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 10.626H82.754V15.134H87.262V10.626Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 15.134H82.754V19.642H87.262V15.134Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 24.15H82.754V28.658H87.262V24.15Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 28.658H82.754V33.166H87.262V28.658Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 37.674H82.754V42.182H87.262V37.674Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 51.198H82.754V55.706H87.262V51.198Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 60.214H82.754V64.722H87.262V60.214Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 73.738H82.754V78.246H87.262V73.738Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 87.262H82.754V91.77H87.262V87.262Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 105.294H82.754V109.802H87.262V105.294Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 109.802H82.754V114.31H87.262V109.802Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 136.85H82.754V141.358H87.262V136.85Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 141.358H82.754V145.866H87.262V141.358Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M87.262 145.866H82.754V150.374H87.262V145.866Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 6.118H87.2621V10.626H91.7701V6.118Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 15.134H87.2621V19.642H91.7701V15.134Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 19.642H87.2621V24.15H91.7701V19.642Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 24.15H87.2621V28.658H91.7701V24.15Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 33.166H87.2621V37.674H91.7701V33.166Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 42.182H87.2621V46.69H91.7701V42.182Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 46.69H87.2621V51.198H91.7701V46.69Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 51.198H87.2621V55.706H91.7701V51.198Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 55.706H87.2621V60.214H91.7701V55.706Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 69.23H87.2621V73.738H91.7701V69.23Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 73.738H87.2621V78.246H91.7701V73.738Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 78.246H87.2621V82.754H91.7701V78.246Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 82.754H87.2621V87.262H91.7701V82.754Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 87.262H87.2621V91.77H91.7701V87.262Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 96.278H87.2621V100.786H91.7701V96.278Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 105.294H87.2621V109.802H91.7701V105.294Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 109.802H87.2621V114.31H91.7701V109.802Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 118.818H87.2621V123.326H91.7701V118.818Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 123.326H87.2621V127.834H91.7701V123.326Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 127.834H87.2621V132.342H91.7701V127.834Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 136.85H87.2621V141.358H91.7701V136.85Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7701 145.866H87.2621V150.374H91.7701V145.866Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M96.278 6.118H91.77V10.626H96.278V6.118Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M96.278 19.642H91.77V24.15H96.278V19.642Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M96.278 24.15H91.77V28.658H96.278V24.15Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M96.278 51.198H91.77V55.706H96.278V51.198Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M96.278 73.738H91.77V78.246H96.278V73.738Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M96.278 78.246H91.77V82.754H96.278V78.246Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M96.278 100.786H91.77V105.294H96.278V100.786Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M96.278 105.294H91.77V109.802H96.278V105.294Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M96.278 127.834H91.77V132.342H96.278V127.834Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M96.278 145.866H91.77V150.374H96.278V145.866Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 10.626H96.2781V15.134H100.786V10.626Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 19.642H96.2781V24.15H100.786V19.642Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 33.166H96.2781V37.674H100.786V33.166Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 37.674H96.2781V42.182H100.786V37.674Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 51.198H96.2781V55.706H100.786V51.198Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 60.214H96.2781V64.722H100.786V60.214Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 69.23H96.2781V73.738H100.786V69.23Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 73.738H96.2781V78.246H100.786V73.738Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 78.246H96.2781V82.754H100.786V78.246Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 91.77H96.2781V96.278H100.786V91.77Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 100.786H96.2781V105.294H100.786V100.786Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 105.294H96.2781V109.802H100.786V105.294Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 114.31H96.2781V118.818H100.786V114.31Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 123.326H96.2781V127.834H100.786V123.326Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 127.834H96.2781V132.342H100.786V127.834Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 132.342H96.2781V136.85H100.786V132.342Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 136.85H96.2781V141.358H100.786V136.85Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 145.866H96.2781V150.374H100.786V145.866Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 6.118H100.786V10.626H105.294V6.118Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 28.658H100.786V33.166H105.294V28.658Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 37.674H100.786V42.182H105.294V37.674Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 46.69H100.786V51.198H105.294V46.69Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 64.722H100.786V69.23H105.294V64.722Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 69.23H100.786V73.738H105.294V69.23Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 73.738H100.786V78.246H105.294V73.738Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 87.262H100.786V91.77H105.294V87.262Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 109.802H100.786V114.31H105.294V109.802Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 118.818H100.786V123.326H105.294V118.818Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 127.834H100.786V132.342H105.294V127.834Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 136.85H100.786V141.358H105.294V136.85Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M105.294 145.866H100.786V150.374H105.294V145.866Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 19.642H105.294V24.15H109.802V19.642Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 24.15H105.294V28.658H109.802V24.15Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 28.658H105.294V33.166H109.802V28.658Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 33.166H105.294V37.674H109.802V33.166Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 37.674H105.294V42.182H109.802V37.674Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 46.69H105.294V51.198H109.802V46.69Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 51.198H105.294V55.706H109.802V51.198Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 55.706H105.294V60.214H109.802V55.706Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 60.214H105.294V64.722H109.802V60.214Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 64.722H105.294V69.23H109.802V64.722Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 69.23H105.294V73.738H109.802V69.23Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 73.738H105.294V78.246H109.802V73.738Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 87.262H105.294V91.77H109.802V87.262Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 105.294H105.294V109.802H109.802V105.294Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 109.802H105.294V114.31H109.802V109.802Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 114.31H105.294V118.818H109.802V114.31Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 141.358H105.294V145.866H109.802V141.358Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M109.802 145.866H105.294V150.374H109.802V145.866Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 15.134H109.802V19.642H114.31V15.134Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 19.642H109.802V24.15H114.31V19.642Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 28.658H109.802V33.166H114.31V28.658Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 37.674H109.802V42.182H114.31V37.674Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 51.198H109.802V55.706H114.31V51.198Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 55.706H109.802V60.214H114.31V55.706Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 60.214H109.802V64.722H114.31V60.214Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 69.23H109.802V73.738H114.31V69.23Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 73.738H109.802V78.246H114.31V73.738Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 87.262H109.802V91.77H114.31V87.262Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 96.278H109.802V100.786H114.31V96.278Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 100.786H109.802V105.294H114.31V100.786Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 109.802H109.802V114.31H114.31V109.802Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 6.118H114.31V10.626H118.818V6.118Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 10.626H114.31V15.134H118.818V10.626Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 19.642H114.31V24.15H118.818V19.642Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 24.15H114.31V28.658H118.818V24.15Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 33.166H114.31V37.674H118.818V33.166Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 37.674H114.31V42.182H118.818V37.674Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 42.182H114.31V46.69H118.818V42.182Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 60.214H114.31V64.722H118.818V60.214Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 69.23H114.31V73.738H118.818V69.23Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 73.738H114.31V78.246H118.818V73.738Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 82.754H114.31V87.262H118.818V82.754Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 87.262H114.31V91.77H118.818V87.262Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 96.278H114.31V100.786H118.818V96.278Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 100.786H114.31V105.294H118.818V100.786Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 114.31H114.31V118.818H118.818V114.31Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 118.818H114.31V123.326H118.818V118.818Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 123.326H114.31V127.834H118.818V123.326Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 127.834H114.31V132.342H118.818V127.834Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 132.342H114.31V136.85H118.818V132.342Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 42.182H118.818V46.69H123.326V42.182Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 51.198H118.818V55.706H123.326V51.198Z",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 55.706H118.818V60.214H123.326V55.706Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 60.214H118.818V64.722H123.326V60.214Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 73.738H118.818V78.246H123.326V73.738Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 78.246H118.818V82.754H123.326V78.246Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 109.802H118.818V114.31H123.326V109.802Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 114.31H118.818V118.818H123.326V114.31Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 132.342H118.818V136.85H123.326V132.342Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 141.358H118.818V145.866H123.326V141.358Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 145.866H118.818V150.374H123.326V145.866Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 46.69H123.326V51.198H127.834V46.69Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 60.214H123.326V64.722H127.834V60.214Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 69.23H123.326V73.738H127.834V69.23Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 78.246H123.326V82.754H127.834V78.246Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 82.754H123.326V87.262H127.834V82.754Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 100.786H123.326V105.294H127.834V100.786Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 105.294H123.326V109.802H127.834V105.294Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 114.31H123.326V118.818H127.834V114.31Z",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 123.326H123.326V127.834H127.834V123.326Z",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 132.342H123.326V136.85H127.834V132.342Z",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 136.85H123.326V141.358H127.834V136.85Z",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 145.866H123.326V150.374H127.834V145.866Z",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M132.342 51.198H127.834V55.706H132.342V51.198Z",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M132.342 55.706H127.834V60.214H132.342V55.706Z",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M132.342 78.246H127.834V82.754H132.342V78.246Z",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M132.342 100.786H127.834V105.294H132.342V100.786Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M132.342 114.31H127.834V118.818H132.342V114.31Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M132.342 132.342H127.834V136.85H132.342V132.342Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 42.182H132.342V46.69H136.85V42.182Z",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 55.706H132.342V60.214H136.85V55.706Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 60.214H132.342V64.722H136.85V60.214Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 87.262H132.342V91.77H136.85V87.262Z",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 91.77H132.342V96.278H136.85V91.77Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 96.278H132.342V100.786H136.85V96.278Z",
    fill: "white"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 100.786H132.342V105.294H136.85V100.786Z",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 105.294H132.342V109.802H136.85V105.294Z",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 114.31H132.342V118.818H136.85V114.31Z",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 118.818H132.342V123.326H136.85V118.818Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 123.326H132.342V127.834H136.85V123.326Z",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 127.834H132.342V132.342H136.85V127.834Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 132.342H132.342V136.85H136.85V132.342Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M136.85 136.85H132.342V141.358H136.85V136.85Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 55.706H136.85V60.214H141.358V55.706Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 73.738H136.85V78.246H141.358V73.738Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 78.246H136.85V82.754H141.358V78.246Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 100.786H136.85V105.294H141.358V100.786Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 105.294H136.85V109.802H141.358V105.294Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 109.802H136.85V114.31H141.358V109.802Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 114.31H136.85V118.818H141.358V114.31Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 123.326H136.85V127.834H141.358V123.326Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 127.834H136.85V132.342H141.358V127.834Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 132.342H136.85V136.85H141.358V132.342Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 136.85H136.85V141.358H141.358V136.85Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 141.358H136.85V145.866H141.358V141.358Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M141.358 145.866H136.85V150.374H141.358V145.866Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 46.69H141.358V51.198H145.866V46.69Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 51.198H141.358V55.706H145.866V51.198Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 55.706H141.358V60.214H145.866V55.706Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 60.214H141.358V64.722H145.866V60.214Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 78.246H141.358V82.754H145.866V78.246Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 87.262H141.358V91.77H145.866V87.262Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 109.802H141.358V114.31H145.866V109.802Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 123.326H141.358V127.834H145.866V123.326Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 127.834H141.358V132.342H145.866V127.834Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 132.342H141.358V136.85H145.866V132.342Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 136.85H141.358V141.358H145.866V136.85Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 42.182H145.866V46.69H150.374V42.182Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 46.69H145.866V51.198H150.374V46.69Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 55.706H145.866V60.214H150.374V55.706Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 60.214H145.866V64.722H150.374V60.214Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 64.722H145.866V69.23H150.374V64.722Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 82.754H145.866V87.262H150.374V82.754Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 100.786H145.866V105.294H150.374V100.786Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 105.294H145.866V109.802H150.374V105.294Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 109.802H145.866V114.31H150.374V109.802Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 114.31H145.866V118.818H150.374V114.31Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 118.818H145.866V123.326H150.374V118.818Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M150.374 123.326H145.866V127.834H150.374V123.326Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 46.69H150.374V51.198H154.882V46.69Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 51.198H150.374V55.706H154.882V51.198Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 60.214H150.374V64.722H154.882V60.214Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 64.722H150.374V69.23H154.882V64.722Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 69.23H150.374V73.738H154.882V69.23Z",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 82.754H150.374V87.262H154.882V82.754Z",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 91.77H150.374V96.278H154.882V91.77Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 100.786H150.374V105.294H154.882V100.786Z",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 105.294H150.374V109.802H154.882V105.294Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 109.802H150.374V114.31H154.882V109.802Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 114.31H150.374V118.818H154.882V114.31Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M154.882 150.374H150.374V154.882H154.882V150.374Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11804 6.118V37.674H37.674V6.118H6.11804ZM10.626 10.626H33.166V33.166H10.626V10.626Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M28.658 15.134H15.134V28.658H28.658V15.134Z",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.882 6.118L123.326 6.118V37.674H154.882V6.118ZM150.374 10.626V33.166H127.834V10.626L150.374 10.626Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M145.866 28.658V15.134H132.342V28.658H145.866Z",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11804 154.882H37.674V123.326H6.11804L6.11804 154.882ZM10.626 150.374L10.626 127.834H33.166V150.374H10.626Z",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M15.134 132.342V145.866H28.658V132.342H15.134Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161 0H0V161H161V0Z",
    fill: "#537FF6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 161,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParaplusQr);
export default __webpack_public_path__ + "static/media/paraplus-qr.d696d32c6fe91aa25bacef2c8c38fb87.svg";
export { ForwardRef as ReactComponent };